{{#> elements/_dt}}
  {{> elements/_label }}
{{/elements/_dt}}
<dd>
  {{#if testIdPrefix}}
    {{sp_select_tag (sp_select_name prefix "[" name "]")
      choices=select_items
      includeBlank=false
      searchable=select_searchable
      selected=value
      id=id
      testId=(dasherize (concat testIdPrefix name))
      required=required
      disabled=disabled
    }}
  {{else}}
    {{sp_select_tag (sp_select_name prefix "[" name "]")
      choices=select_items
      includeBlank=false
      searchable=select_searchable
      selected=value
      id=id
      required=required
      disabled=disabled
    }}
  {{/if}}
</dd>
